/**
 * IntelliGems A/B Test: Addon Upsell Popup on ATC
 *
 * Control (A): default add-to-cart behaviour
 * Variant (B): popup on ATC — nothing added until user confirms or skips
 */
(function () {
  'use strict';

  if (window.__addonUpsellABTestInit) return;
  window.__addonUpsellABTestInit = true;

  var BODY_ATTR = 'data-addon-upsell-popup';
  var PORTAL_ATTR = 'data-addon-upsell-portal';
  var busy = false;
  var config = null;
  var resolvedProducts = null;
  var modalEl = null;
  var selectedProducts = {};
  var pendingForm = null;
  var suppressCartOpen = false;
  var upcartObserver = null;
  var suppressInterval = null;
  var modalGuardInterval = null;

  function repairPageVisibility() {
    var body = document.body;
    if (!body) return;

    if (body.style.display === 'none') body.style.display = '';
    if (body.getAttribute('aria-hidden') === 'true') body.removeAttribute('aria-hidden');
  }

  repairPageVisibility();

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('addon_upsell_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isVariantB() {
    if (isDevVariantB()) return true;
    var body = document.body;
    return body && body.getAttribute(BODY_ATTR) === 'true';
  }

  function shouldIntercept() {
    if (!isVariantB()) return false;
    var cfg = getConfig();
    return !!(cfg && cfg.products && cfg.products.length > 0);
  }

  function getConfig() {
    if (config) return config;
    var el = document.getElementById('addon-upsell-config');
    if (!el) return null;
    try {
      config = JSON.parse(el.textContent);
    } catch (e) {
      config = null;
    }
    return config;
  }

  function installCartOpenBlockers() {
    document.addEventListener('product:added', function (event) {
      if (!suppressCartOpen) return;
      event.stopImmediatePropagation();
    }, true);

    document.addEventListener('cart:refresh', function (event) {
      if (!suppressCartOpen) return;
      event.stopImmediatePropagation();
    }, true);
  }

  function injectUpcartHideStyle() {
    if (document.getElementById('addon-upsell-hide-upcart')) return;

    var style = document.createElement('style');
    style.id = 'addon-upsell-hide-upcart';
    style.textContent =
      'html.addon-upsell-open upcart-cart-drawer,' +
      'html.addon-upsell-open #upcart,' +
      'html.addon-upsell-open [id^="upcart"],' +
      'html.addon-upsell-open .upcart-cart-drawer,' +
      'html.addon-upsell-open [class*="UpCartDrawer"],' +
      'html.addon-upsell-open [class*="upcart-drawer"],' +
      'html.addon-upsell-open [data-upcart-cart] {' +
      'display: none !important;' +
      'visibility: hidden !important;' +
      'opacity: 0 !important;' +
      'pointer-events: none !important;' +
      'transform: translateX(100%) !important;' +
      '}';
    document.head.appendChild(style);
  }

  function removeUpcartHideStyle() {
    var style = document.getElementById('addon-upsell-hide-upcart');
    if (style) style.remove();

    document.querySelectorAll('upcart-cart-drawer, #upcart, [id^="upcart"]').forEach(function (el) {
      if (el === document.body) return;
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.style.removeProperty('opacity');
      el.style.removeProperty('transform');
    });
  }

  function closeCartDrawers() {
    repairPageVisibility();

    if (document.body) {
      document.body.classList.remove('upcartPopupShow');
    }

    var nativeClose = document.querySelector('#sidebar-cart [data-action="close-drawer"]');
    if (nativeClose) nativeClose.click();

    var drawer = document.getElementById('sidebar-cart');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');

    var overlay = document.querySelector('.PageOverlay');
    if (overlay) overlay.classList.remove('is-visible');

    if (window.UpCart) {
      if (typeof window.UpCart.close === 'function') window.UpCart.close();
      if (typeof window.UpCart.closeCart === 'function') window.UpCart.closeCart();
    }

    var upcartDrawer = document.querySelector('upcart-cart-drawer');
    if (upcartDrawer) upcartDrawer.setAttribute('aria-hidden', 'true');
  }

  function installUpcartBlocker() {
    if (!document.body || upcartObserver) return;

    upcartObserver = new MutationObserver(function () {
      if (!suppressCartOpen) return;
      if (document.body.classList.contains('upcartPopupShow')) {
        document.body.classList.remove('upcartPopupShow');
        closeCartDrawers();
      }
    });

    upcartObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function startSuppressingCartOpen() {
    suppressCartOpen = true;
    injectUpcartHideStyle();
    installUpcartBlocker();
    closeCartDrawers();

    clearInterval(suppressInterval);
    var attempts = 0;
    suppressInterval = setInterval(function () {
      closeCartDrawers();
      attempts += 1;
      if (attempts >= 30) {
        clearInterval(suppressInterval);
        suppressInterval = null;
      }
    }, 100);
  }

  function startModalGuard() {
    clearInterval(modalGuardInterval);
    modalGuardInterval = setInterval(closeCartDrawers, 250);
  }

  function stopModalGuard() {
    clearInterval(modalGuardInterval);
    modalGuardInterval = null;
  }

  function stopSuppressingCartOpen() {
    suppressCartOpen = false;
    clearInterval(suppressInterval);
    suppressInterval = null;
    stopModalGuard();
    removeUpcartHideStyle();
  }

  function portalToBody() {
    document.querySelectorAll('[' + PORTAL_ATTR + ']').forEach(function (el) {
      if (el.parentNode && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
    });
  }

  function getModal() {
    var cfg = getConfig();
    if (!cfg || !cfg.modalId) return null;
    if (!modalEl || !document.body.contains(modalEl)) {
      modalEl = document.getElementById(cfg.modalId);
    }
    return modalEl;
  }

  function openModal() {
    var modal = getModal();
    if (!modal) return;

    startSuppressingCartOpen();
    startModalGuard();
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('addon-upsell-open');
    closeCartDrawers();
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;

    document.documentElement.classList.add('addon-upsell--instant');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('addon-upsell-open');
    stopSuppressingCartOpen();

    requestAnimationFrame(function () {
      document.documentElement.classList.remove('addon-upsell--instant');
    });
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function formatMoneyFromCents(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function mapShopifyProduct(product) {
    if (!product || !product.variants || !product.variants.length) return null;

    var variant = null;
    var i;
    for (i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) {
        variant = product.variants[i];
        break;
      }
    }
    if (!variant) return null;

    var image = product.featured_image;
    if (typeof image === 'object' && image && image.src) image = image.src;

    return {
      id: product.id,
      title: product.title,
      handle: product.handle,
      url: product.url || '/products/' + product.handle,
      featured_image: image || null,
      price: variant.price,
      price_formatted: formatMoneyFromCents(variant.price),
      compare_at_price: variant.compare_at_price || 0,
      compare_at_price_formatted: formatMoneyFromCents(variant.compare_at_price || 0),
      variant_id: variant.id,
      available: true
    };
  }

  function fetchRecommendationProducts(productId, intent) {
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=' + intent, {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      return (data.products || []).map(mapShopifyProduct).filter(Boolean);
    }).catch(function () {
      return [];
    });
  }

  function loadProducts() {
    if (resolvedProducts) return Promise.resolve(resolvedProducts);

    var cfg = getConfig();
    if (!cfg || !cfg.products || !cfg.products.length) {
      resolvedProducts = [];
      return Promise.resolve(resolvedProducts);
    }

    resolvedProducts = cfg.products.filter(function (product) {
      return product.available && product.variant_id && product.id !== cfg.productId;
    });

    return Promise.resolve(resolvedProducts);
  }

  function renderProducts(products) {
    var cfg = getConfig();
    var modal = getModal();
    if (!cfg || !modal) return;

    var container = modal.querySelector('[data-addon-upsell-products]');
    var cta = modal.querySelector('[data-addon-upsell-cta]');
    if (!container) return;

    container.innerHTML = '';
    selectedProducts = {};

    if (!products.length) {
      container.innerHTML = '<p class="addon-upsell__empty">No addon products available.</p>';
      if (cta) updateCtaLabel(cta);
      return;
    }

    products.forEach(function (product) {
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'addon-upsell__card';
      card.setAttribute('data-addon-upsell-product', '');
      card.setAttribute('data-variant-id', String(product.variant_id));
      card.setAttribute('aria-pressed', 'false');

      var imageHtml = product.featured_image
        ? '<img class="addon-upsell__card-image" src="' + product.featured_image + '" alt="" loading="lazy">'
        : '<div class="addon-upsell__card-image addon-upsell__card-image--placeholder"></div>';

      var salePrice = formatMoneyFromCents(product.price);
      var comparePrice = formatMoneyFromCents(product.compare_at_price || 0);

      var priceHtml = product.compare_at_price > product.price
        ? '<span class="addon-upsell__card-price addon-upsell__card-price--sale">' + escapeHtml(salePrice) + '</span>' +
          '<span class="addon-upsell__card-price addon-upsell__card-price--compare">' + escapeHtml(comparePrice) + '</span>'
        : '<span class="addon-upsell__card-price">' + escapeHtml(salePrice) + '</span>';

      card.innerHTML =
        '<span class="addon-upsell__card-check" aria-hidden="true">' +
          '<svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M3 8.5L6.5 12L13 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>' +
        imageHtml +
        '<span class="addon-upsell__card-body">' +
          '<span class="addon-upsell__card-title">' + escapeHtml(product.title) + '</span>' +
          '<span class="addon-upsell__card-prices">' + priceHtml + '</span>' +
        '</span>';

      card.addEventListener('click', function () {
        toggleAddonSelection(product, card);
      });

      container.appendChild(card);
    });

    if (cta) updateCtaLabel(cta);
  }

  function getSelectedCount() {
    return Object.keys(selectedProducts).length;
  }

  function updateCtaLabel(cta) {
    var cfg = getConfig();
    if (!cta || !cfg) return;

    var count = getSelectedCount();
    if (count > 0) {
      cta.textContent = 'Add ' + count + ' selected & continue';
      cta.disabled = false;
      cta.classList.remove('is-disabled');
    } else {
      cta.textContent = cfg.ctaLabel || 'Continue to cart';
      cta.disabled = true;
      cta.classList.add('is-disabled');
    }
  }

  function setCardSelected(card, selected) {
    card.classList.toggle('is-selected', selected);
    card.setAttribute('aria-pressed', selected ? 'true' : 'false');
  }

  function toggleAddonSelection(product, card) {
    var variantId = String(product.variant_id);

    if (selectedProducts[variantId]) {
      delete selectedProducts[variantId];
      setCardSelected(card, false);
    } else {
      selectedProducts[variantId] = product;
      setCardSelected(card, true);
    }

    var cta = modalEl && modalEl.querySelector('[data-addon-upsell-cta]');
    updateCtaLabel(cta);
  }

  function buildCartItems(form, includeAddons) {
    var formData = serializeForm(form);
    var items = [];
    var mainItem = {
      id: parseInt(formData.id, 10),
      quantity: parseInt(formData.quantity || 1, 10)
    };
    var properties = {};
    var key;
    var match;

    for (key in formData) {
      if (!Object.prototype.hasOwnProperty.call(formData, key)) continue;
      match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = formData[key];
    }

    if (Object.keys(properties).length) {
      mainItem.properties = properties;
    }

    items.push(mainItem);

    if (includeAddons) {
      Object.keys(selectedProducts).forEach(function (variantId) {
        items.push({ id: parseInt(variantId, 10), quantity: 1 });
      });
    }

    return items;
  }

  function addItemsToCart(form, includeAddons) {
    return fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: buildCartItems(form, includeAddons) })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (content) {
          throw new Error(content.description || 'Could not add to cart');
        });
      }
      return response.json();
    });
  }

  function serializeForm(form) {
    var data = {};
    var formData = new FormData(form);
    formData.forEach(function (value, key) {
      data[key] = value;
    });
    return data;
  }

  function showFormError(form, message) {
    var button = form.querySelector('.ProductForm__AddToCart');
    if (!button) return;

    var existing = form.querySelector('.ProductForm__Error');
    if (existing) existing.remove();

    var errorEl = document.createElement('span');
    errorEl.className = 'ProductForm__Error Alert Alert--error';
    errorEl.textContent = message;
    button.insertAdjacentElement('afterend', errorEl);
    setTimeout(function () { errorEl.remove(); }, 3000);
  }

  function updateHeaderCartCount(itemCount) {
    document.querySelectorAll('.Header__CartCount').forEach(function (el) {
      el.textContent = itemCount;
    });

    document.querySelectorAll('.Header__CartDot').forEach(function (dot) {
      if (itemCount > 0) dot.classList.add('is-visible');
      else dot.classList.remove('is-visible');
    });
  }

  function refreshNativeMiniCart() {
    return fetch(window.routes.cartUrl + '?section_id=mini-cart&timestamp=' + Date.now(), {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.text();
    }).then(function (html) {
      var drawer = document.getElementById('sidebar-cart');
      if (!drawer) return;

      var temp = document.createElement('div');
      temp.innerHTML = html;
      var newCart = temp.querySelector('.Cart');
      var oldCart = drawer.querySelector('.Cart');

      if (newCart && oldCart && oldCart.parentNode) {
        oldCart.parentNode.replaceChild(newCart, oldCart);
      }
    }).catch(function () {
      /* native drawer may not exist when UpCart is active */
    });
  }

  function refreshCartData() {
    return fetch(window.routes.cartUrl + '.js', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      return response.json();
    }).then(function (cart) {
      updateHeaderCartCount(cart.item_count);
      return cart;
    });
  }

  function openUpCartDrawer() {
    if (window.UpCart) {
      if (typeof window.UpCart.refresh === 'function') window.UpCart.refresh();
      if (typeof window.UpCart.updateCart === 'function') window.UpCart.updateCart();
      if (typeof window.UpCart.open === 'function') {
        window.UpCart.open();
        return true;
      }
      if (typeof window.UpCart.show === 'function') {
        window.UpCart.show();
        return true;
      }
    }

    if (window.upcart && typeof window.upcart.open === 'function') {
      window.upcart.open();
      return true;
    }

    try {
      document.dispatchEvent(new CustomEvent('upcart:open'));
      document.dispatchEvent(new CustomEvent('upcart:refresh'));
      return true;
    } catch (e) {
      return false;
    }
  }

  function openNativeCartDrawer() {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return false;

    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');

    var overlay = document.querySelector('.PageOverlay');
    if (overlay) overlay.classList.add('is-visible');

    return true;
  }

  function openCartImmediate() {
    stopSuppressingCartOpen();
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    if (openUpCartDrawer()) return;
    if (openNativeCartDrawer()) return;

    var drawerTrigger = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
    if (drawerTrigger) drawerTrigger.click();
  }

  function refreshCartInBackground() {
    refreshCartData().catch(function () {});

    if (window.UpCart) {
      if (typeof window.UpCart.refresh === 'function') window.UpCart.refresh();
      if (typeof window.UpCart.updateCart === 'function') window.UpCart.updateCart();
    }

    refreshNativeMiniCart().catch(function () {});
  }

  function openCart() {
    openCartImmediate();
    refreshCartInBackground();
  }

  function onCtaClick() {
    if (busy || getSelectedCount() === 0 || !pendingForm) return;

    busy = true;
    var form = pendingForm;
    var cta = modalEl && modalEl.querySelector('[data-addon-upsell-cta]');
    if (cta) cta.disabled = true;

    pendingForm = null;
    closeModal();
    openCartImmediate();

    addItemsToCart(form, true)
      .then(function (cart) {
        if (cart && cart.item_count !== undefined) {
          updateHeaderCartCount(cart.item_count);
        }
        refreshCartInBackground();
      })
      .catch(function (err) {
        console.error('[addon-upsell]', err);
        showFormError(form, err.message);
      })
      .finally(function () {
        busy = false;
      });
  }

  function onSkipClick() {
    if (busy) return;

    if (!pendingForm) {
      closeModal();
      return;
    }

    busy = true;
    var form = pendingForm;
    pendingForm = null;
    closeModal();
    openCartImmediate();

    addItemsToCart(form, false)
      .then(function () {
        refreshCartInBackground();
      })
      .catch(function (err) {
        console.error('[addon-upsell]', err);
        showFormError(form, err.message);
      })
      .finally(function () {
        busy = false;
      });
  }

  function handleVariantBSubmit(form) {
    if (busy) return;
    if (!getConfig()) return;

    pendingForm = form;
    selectedProducts = {};
    resolvedProducts = null;
    startSuppressingCartOpen();

    portalToBody();

    loadProducts()
      .then(function (products) {
        if (!products.length) {
          stopSuppressingCartOpen();
          var formToSubmit = pendingForm;
          pendingForm = null;
          if (formToSubmit) {
            if (typeof formToSubmit.requestSubmit === 'function') {
              formToSubmit.requestSubmit();
            } else {
              formToSubmit.submit();
            }
          }
          return;
        }
        renderProducts(products);
        openModal();
      })
      .catch(function (err) {
        stopSuppressingCartOpen();
        pendingForm = null;
        showFormError(form, err.message);
      });
  }

  function onFormSubmit(event) {
    if (!shouldIntercept()) return;
    var form = event.target;
    if (!form || !form.classList.contains('ProductForm')) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    handleVariantBSubmit(form);
  }

  function onAddToCartClick(event) {
    if (!shouldIntercept()) return;
    var button = event.target.closest('[data-action="add-to-cart"]');
    if (!button) return;
    var form = button.closest('form.ProductForm');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    handleVariantBSubmit(form);
  }

  function attachModalListeners() {
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-addon-upsell-close]')) {
        event.preventDefault();
        onSkipClick();
        return;
      }

      if (event.target.closest('[data-addon-upsell-cta]')) {
        event.preventDefault();
        if (!event.target.closest('[data-addon-upsell-cta]').disabled) {
          onCtaClick();
        }
        return;
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var modal = getModal();
      if (!modal || modal.getAttribute('aria-hidden') !== 'false') return;
      onSkipClick();
    });
  }

  function init() {
    repairPageVisibility();
    installCartOpenBlockers();
    installUpcartBlocker();
    portalToBody();
    attachModalListeners();
    document.addEventListener('submit', onFormSubmit, true);
    document.addEventListener('click', onAddToCartClick, true);
    document.addEventListener('shopify:section:load', portalToBody);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
